function NotFound() {
    return (
        <main>
            <h1>Sorry, Page not found</h1>
        </main>
    )
}

export default NotFound;
